import { motion } from "framer-motion";

const JobIllustration = () => {
  return (
    <div className="w-full h-full relative">
      <div className="absolute inset-0 bg-gradient-to-br from-red-50 to-rose-100"></div>
      <motion.svg
        width="400"
        height="400"
        viewBox="0 0 500 500"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute inset-0 m-auto"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        {/* Background circle */}
        <motion.circle
          cx="250"
          cy="250"
          r="160"
          fill="#F5F5FF"
          stroke="#C71F2C"
          strokeWidth="4"
          strokeDasharray="8 8"
          initial={{ scale: 0 }}
          animate={{ scale: 1, rotate: 360 }}
          transition={{
            scale: { type: "spring", stiffness: 60, damping: 15 },
            rotate: { duration: 30, repeat: Infinity, ease: "linear" },
          }}
        />

        <motion.g
          initial={{ scale: 0, y: 20 }}
          animate={{ scale: 1, y: 0 }}
          transition={{ delay: 0.5, type: "spring", stiffness: 100 }}
        >
          <motion.rect x="235" y="230" width="30" height="50" rx="10" fill="#C71F2C" />

          <motion.circle cx="250" cy="210" r="20" fill="#FDB4B4" stroke="#C71F2C" strokeWidth="2" />

          <motion.path
            d="M235 240L200 220M265 240L300 220"
            stroke="#C71F2C"
            strokeWidth="5"
            strokeLinecap="round"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ delay: 0.8, duration: 0.6 }}
          />
        </motion.g>

        <motion.g
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 1.2, type: "spring" }}
        >
          <motion.circle cx="150" cy="150" r="40" fill="white" stroke="#C71F2C" strokeWidth="3" />
          <motion.path
            d="M135 150L125 140L135 130M165 150L175 140L165 130"
            stroke="#C71F2C"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ delay: 1.4, duration: 0.5 }}
          />
          <motion.path
            d="M145 160L155 140"
            stroke="#C71F2C"
            strokeWidth="3"
            strokeLinecap="round"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ delay: 1.6, duration: 0.3 }}
          />
        </motion.g>

        <motion.g
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 1.5, type: "spring" }}
        >
          <motion.circle cx="350" cy="150" r="40" fill="white" stroke="#C71F2C" strokeWidth="3" />
          <motion.path
            d="M330 150C330 140 340 130 350 130C360 130 370 140 370 150C370 160 360 170 350 170"
            stroke="#C71F2C"
            strokeWidth="3"
            strokeLinecap="round"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ delay: 1.7, duration: 0.7 }}
          />
          <motion.circle
            cx="350"
            cy="150"
            r="5"
            fill="#C71F2C"
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 2.0, duration: 0.3 }}
          />
        </motion.g>

        <motion.g
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 1.8, type: "spring" }}
        >
          <motion.circle cx="150" cy="350" r="40" fill="white" stroke="#C71F2C" strokeWidth="3" />
          <motion.path
            d="M135 340H165M135 350H165M135 360H165"
            stroke="#C71F2C"
            strokeWidth="3"
            strokeLinecap="round"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ delay: 2.0, duration: 0.7 }}
          />
        </motion.g>

        <motion.g
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 2.1, type: "spring" }}
        >
          <motion.circle cx="350" cy="350" r="40" fill="white" stroke="#C71F2C" strokeWidth="3" />
          <motion.path
            d="M335 340L350 330L365 340L365 360L350 370L335 360L335 340Z"
            stroke="#C71F2C"
            strokeWidth="3"
            fill="#FFF0F0"
            strokeLinejoin="round"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ delay: 2.3, duration: 0.7 }}
          />
        </motion.g>

        <motion.path
          d="M220 210L170 170"
          stroke="#C71F2C"
          strokeWidth="2"
          strokeDasharray="5 5"
          initial={{ pathLength: 0, opacity: 0 }}
          animate={{ pathLength: 1, opacity: 1 }}
          transition={{ delay: 2.5, duration: 0.6 }}
        />
        <motion.path
          d="M280 210L330 170"
          stroke="#C71F2C"
          strokeWidth="2"
          strokeDasharray="5 5"
          initial={{ pathLength: 0, opacity: 0 }}
          animate={{ pathLength: 1, opacity: 1 }}
          transition={{ delay: 2.7, duration: 0.6 }}
        />
        <motion.path
          d="M220 260L170 330"
          stroke="#C71F2C"
          strokeWidth="2"
          strokeDasharray="5 5"
          initial={{ pathLength: 0, opacity: 0 }}
          animate={{ pathLength: 1, opacity: 1 }}
          transition={{ delay: 2.9, duration: 0.6 }}
        />
        <motion.path
          d="M280 260L330 330"
          stroke="#C71F2C"
          strokeWidth="2"
          strokeDasharray="5 5"
          initial={{ pathLength: 0, opacity: 0 }}
          animate={{ pathLength: 1, opacity: 1 }}
          transition={{ delay: 3.1, duration: 0.6 }}
        />

        <motion.circle
          cx="150"
          cy="150"
          r="50"
          stroke="#C71F2C"
          strokeWidth="3"
          fill="transparent"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{
            scale: [0.8, 1.1, 0.8],
            opacity: [0, 0.6, 0],
          }}
          transition={{
            delay: 3.3,
            duration: 1.5,
            repeat: Infinity,
            repeatDelay: 1,
          }}
        />

        <motion.g>
          <motion.path
            d="M120 120L125 125M105 145L110 150M135 100L140 105M175 120L180 125"
            stroke="#C71F2C"
            strokeWidth="2"
            strokeLinecap="round"
            initial={{ opacity: 0 }}
            animate={{ opacity: [0, 1, 0] }}
            transition={{
              delay: 3.5,
              duration: 1.2,
              repeat: Infinity,
              repeatDelay: 1.3,
            }}
          />
        </motion.g>
      </motion.svg>
    </div>
  );
};

export default JobIllustration;
